import { Component } from '@angular/core'
import { Router } from '@angular/router'

@Component({
  selector: 'shared-upgrade-tier-banner',
  templateUrl: './upgrade-tier-banner.component.html',
  styleUrls: ['./upgrade-tier-banner.component.css'],
  standalone: false
})
export class UpgradeTierBannerComponent {
  constructor(private _router: Router) { }

  upgrade() {
    this._router.navigate(['upgrade'])
  }
}